<template>
  <div>
    <div v-if="(this.desktop || this.largeDesktop) && (modalCreateOtvt || modalCreateConsignment)">
      <div class="required-documents mb-1">Обязательные документы при создании заявки (железнодорожная перевозка):
      </div>
      <div class="documents-list mb-1">
        <div class="mr-3">Железнодорожная накладная СМГС</div>
        <div class="mr-3">Инвойс</div>
      </div>
      <div class="additional-documents mb-1">При недостатке информации декларантом могут быть запрошены:</div>
      <div class="documents-list mb-4">
        <div class="mr-3">Упаковочные листы</div>
        <div class="mr-3">Сертификаты</div>
        <div class="mr-3">Спецификации и прочее</div>
      </div>
    </div>

    <div v-if="modalEditOtvt || modalEditConsignment">
      <div v-if="this.desktop || this.largeDesktop">
        <div class="mr-5 ml-5">
          <div class="pkg-number d-inline-block mr-3"><span>№ заявки:</span> {{ chain_number }}</div>
          <div class="package-created-date d-inline-block"><span>Создан:</span> {{ data_created_package }}</div>
        </div>
        <div class="mr-5 ml-5">
          <b-alert variant="danger" v-if="message && message.length" class="text-lowercase comment-text" show>
            <i class="fas fa-exclamation-triangle mr-2"></i>{{ message }}
          </b-alert>
        </div>
      </div>
      <div v-if="this.mobile || this.tablet">
        <div class="pkg-number r-3"><span>№ заявки:</span> {{ chain_number }}</div>
        <div>
          <b-alert variant="danger" v-if="message && message.length" class="text-lowercase comment-text" show>
            <i class="fas fa-exclamation-triangle mr-2"></i>{{ message }}
          </b-alert>
        </div>
      </div>
    </div>

    <div v-if="this.desktop || this.largeDesktop">
      <div class="file-attachment mb-3 mr-5 ml-5"
           v-if="editFiles && (editFiles.length > 0) && (deletedFilesCount !== editFiles.length)">Вложенные документы:
      </div>
    </div>

    <div :class="{ 'edit-files-wrapper': true, 'mb-4 mr-5 ml-5': !!(desktop || largeDesktop) }"
         v-if="editFiles && (editFiles.length > 0) && (deletedFilesCount !== editFiles.length)">
      <div v-if="editFiles" class="attachments-wrapper">
        <div v-for="inp in editFiles"
             v-show="inp.deleted!==true"
             :key="inp.id"
             class="attachment"
             @click="loadFile($event, inp.link)"
             :style="({ width: (desktop || largeDesktop) ? (attachmentWidth + 'px') : '266px'})"
             :title="inp.name">
          <div class="attachment-inner-container">
            <div class="file-icon-wrapper">
              <i :class="[inp.icon, 'file-icon']"></i>
              <div class="remove-file-button"
                   :id="inp.id"
                   @click="removeFile($event, inp.id)">
                <i class="fas fa-times-circle"></i>
              </div>
            </div>
            <div class="attachment-name-wrapper">
              <div class="mb-5 mr-4">{{ inp.name }}</div>
              <span class="badge file-size" v-html="calcFileSize(inp.size)"
                    :style="{ backgroundColor: '#78909C' }"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="(desktop || largeDesktop) ? 'mr-5 ml-5' : ''">
      <b-alert variant="danger" show v-if="maxFileSize > 0" class="file-size-error">
        Ошибка загрузки файла! Максимальный размер <b>10Мб</b>.
      </b-alert>
    </div>

    <div class="example-drag">
      <div class="upload">
        <div :class="{ 'up-edit-files-wrapper': true, 'mb-3 mr-5 ml-5': !!(desktop || largeDesktop) }" :style="addBorderStyle()">
          <div class="attachments-wrapper">
            <div v-for="inp in files"
                 :key="inp.id"
                 class="up-attachment"
                 :style="({ width: (desktop || largeDesktop) ? (attachmentWidth + 'px') : '266px'})">
              <div class="attachment-inner-container">
                <div class="file-icon-wrapper">
                  <i :class="[inp.icon, 'file-icon']"></i>
                  <div class="remove-file-button"
                       :id="inp.id"
                       @click.prevent="$refs.upload.remove(inp)">
                    <i class="fas fa-times-circle" :style="{ color: '#e7161a', fontSize: '21px' }"></i>
                  </div>
                </div>
                <div class="attachment-name-wrapper">
                  <div class="mb-5 mr-4">{{ inp.name }}</div>
                  <span
                    :class="{ 'badge': true, 'file-size': true, 'badge-danger': (inp.size >= 1024*1024*10), 'badge-secondary': (inp.size < 1024*1024*10) }"
                    v-html="calcFileSize(inp.size)"></span>
                </div>
              </div>
            </div>
            <file-upload
              id="file-upload"
              :class="{ ' ml-5 mr-5': !!(desktop || largeDesktop) }"
              :multiple="true"
              :drop="true"
              :drop-directory="true"
              :value="files"
              @input="inputUpdate"
              @input-file="inputFiles"
              ref="upload">
              <div class="text-center p-5" v-show="!files.length">
                <div v-if="mobile || tablet">
                  <h5 class="upload-caption-header">Загрузить файлы</h5>
                  <div class="upload-caption">Поддерживаются форматы XLS (XLSX), PDF, JPG или PNG.</div>
                  <div class="upload-caption">Максимальный размер файла - 10 Мб.</div>
                </div>
                <div v-if="desktop || largeDesktop">
                  <img src="../assets/icon-invoice-smgs.svg" class="icon-invoice-smgs mb-3"/>
                  <h5 class="upload-caption-header">Перетащите файлы документов в это окно</h5>
                  <div class="upload-caption mb-2">Или кликните, чтобы загрузить их с компьютера</div>
                  <div class="upload-caption">Документы должны быть в формате XLS (XLSX), PDF, JPG или PNG.</div>
                  <div class="upload-caption">Максимальный размер файла - 10 Мб.</div>
                </div>
              </div>
            </file-upload>
          </div>
        </div>
        <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active"></div>
      </div>
    </div>
    <div slot="modal-footer" :style="(desktop || largeDesktop) ? 'width: 100%' : ''">
      <b-row>
        <b-col sm="3"></b-col>

        <b-col sm="6" class="send-reset" v-if="modalCreateOtvt">
          <b-btn variant="danger" @click="handleCancel" class="float-left action-button">Отменить</b-btn>
          <b-btn
            :variant="(!files.length || maxFileSize>0) ? 'secondary' : 'success'"
            :disabled="(!files.length || maxFileSize>0)"
            @click="$emit('save', $event)"
            class="float-right action-button">Отправить
          </b-btn>
        </b-col>

        <b-col :sm="(mobile || tablet) ? '12' : '6'" class="send-reset" v-if="modalCreateConsignment">
          <div v-if="mobile || tablet" class="d-flex align-items-center justify-content-between">
            <b-btn size="md" variant="danger" @click="handleCancel" class=" mr-3 action-button"><span>Отменить</span>
            </b-btn>
            <b-btn
              size="md"
              :variant="((Boolean(!files.length) || maxFileSize>0) && (Boolean(!consignmentsInfo.length) || maxFileSize>0)) ? 'secondary' : 'success'"
              :disabled="((Boolean(!files.length) || maxFileSize>0) && (Boolean(!consignmentsInfo.length) || maxFileSize>0))"
              @click="$emit('save', $event)"
              class="action-button"><span>Отправить</span>
            </b-btn>
          </div>
          <div v-if="desktop || largeDesktop">
            <b-btn variant="danger" @click="handleCancel" class="float-left action-button">Отменить</b-btn>
            <b-btn
              :variant="((Boolean(!files.length) || maxFileSize>0) && (Boolean(!consignmentsInfo.length) || maxFileSize>0)) ? 'secondary' : 'success'"
              :disabled="((Boolean(!files.length) || maxFileSize>0) && (Boolean(!consignmentsInfo.length) || maxFileSize>0))"
              @click="$emit('save', $event)"
              class="float-right action-button">Отправить
            </b-btn>
          </div>
        </b-col>

        <b-col sm="6" class="send-reset" v-if="modalEditOtvt">
          <b-btn variant="danger" @click="handleCancel" class="float-left action-button">Отменить</b-btn>
          <b-btn
            :variant="(maxFileSize > 0 || (deletedFilesCount===0 && !files.length)) ? 'secondary' : 'success'"
            :disabled="maxFileSize > 0 || (deletedFilesCount===0 && !files.length)" @click="$emit('edit', $event)"
            class="float-right action-button">Сохранить
          </b-btn>
        </b-col>

        <b-col :sm="(mobile || tablet) ? '12' : '6'" class="send-reset" v-if="modalEditConsignment">
          <div v-if="mobile || tablet" class="d-flex align-items-center justify-content-between">
            <b-btn size="md" variant="danger" @click="handleCancel" class=" mr-3 action-button"><span>Отменить</span>
            </b-btn>
            <b-btn
              size="md"
              :variant="(maxFileSize > 0 || (deletedFilesCount===0 && Boolean(!files.length)) ||
                      ((allFilesDeleted.length === editFiles.length) && (files.length === 0))) ? 'secondary' : 'success'"
              :disabled="(maxFileSize > 0 || (deletedFilesCount===0 && Boolean(!files.length)) ||
                      ((allFilesDeleted.length === editFiles.length) && (files.length === 0)))"
              @click="$emit('edit', $event)"
              class="action-button"><span>Сохранить</span>
            </b-btn>
          </div>
          <div v-if="desktop || largeDesktop">
            <b-btn variant="danger" @click="handleCancel" class="float-left action-button">Отменить</b-btn>
            <b-btn
              :variant="(maxFileSize > 0 || (deletedFilesCount===0 && Boolean(!files.length)) ||
                      ((allFilesDeleted.length === editFiles.length) && (files.length === 0))) ? 'secondary' : 'success'"
              :disabled="(maxFileSize > 0 || (deletedFilesCount===0 && Boolean(!files.length)) ||
                      ((allFilesDeleted.length === editFiles.length) && (files.length === 0)))"
              @click="$emit('edit', $event)"
              class="float-right action-button">Сохранить
            </b-btn>
          </div>
        </b-col>

        <b-col sm="3"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'ModalPackageForm',
  props: [
    'attachmentWidth',
    'chain_number',
    'data_created_package',
    'message',
    'editFiles',
    'deletedFilesCount',
    'modalCreateOtvt',
    'modalEditOtvt',
    'modalCreateConsignment',
    'modalEditConsignment',
    'consignmentsInfo'
  ],
  components: {
    FileUpload
  },
  data () {
    return {
      maxFileSize: 0
    }
  },
  watch: {
    mobile (to, from) {
      console.log(to)
      if (to) {

      }
    },
    tablet (to, from) {
      console.log(to)
      if (to) {

      }
    },
    desktop (to, from) {
      console.log(to)
      if (to) {

      }
    },
    largeDesktop (to, from) {
      console.log(to)
      if (to) {

      }
    }
  },
  mounted () {

  },
  methods: {
    ...mapActions([]),
    ...mapMutations([]),
    loadFile ($event, link) {
      window.open(link, '_blank')
    },
    updateConsignmentsInfo (value) {
      this.$emit('update_consignments_info', value)
    },
    removeFile (event, id) {
      event.stopPropagation()
      this.$emit('remove', id)
    },
    inputUpdate (files) {
      this.$store.commit('updateFiles', files)
    },
    inputFiles (newFile, oldFile) {
      if (newFile && !oldFile) {
        if (newFile.size > 1024 * 1024 * 10) {
          this.maxFileSize++
        }
      }
      if (!newFile && oldFile) {
        if (oldFile.size > 1024 * 1024 * 10) {
          this.maxFileSize--
        }
      }
    },
    handleCancel () {
      this.$root.$emit('bv::hide::modal', 'modalCreatePackage', event)
      this.$root.$emit('bv::hide::modal', 'modalEditPackage', event)
      this.$root.$emit('bv::hide::modal', 'modalCreateConsignment', event)
      this.$root.$emit('bv::hide::modal', 'modalEditConsignment', event)
    },
    addBorderStyle () {
      if (this.mobile || this.tablet) {
        return { border: 'none !important' }
      }
      if (this.desktop || this.largeDesktop) {
        return { border: this.maxFileSize > 0 ? '4px solid #e7161a !important' : '4px solid #cfd8dc !important' }
      }
    },
    calcFileSize (FileSize) {
      const FileSizeInKb = Math.floor(FileSize / 1024)
      let FileSizeInMb = 0
      let FileSizeInGb = 0
      if (FileSizeInKb > 0) {
        FileSizeInMb = Math.floor(FileSizeInKb / 1024)
        if (FileSizeInMb > 0) {
          FileSizeInGb = Math.floor(FileSizeInMb / 1024)
          if (FileSizeInGb > 0) {
            return '<span>' + FileSizeInGb + ' Гб</span>'
          } else {
            return '<span>' + FileSizeInMb + ' Мб</span>'
          }
        } else {
          return '<span>' + FileSizeInKb + ' Кб</span>'
        }
      } else {
        return '<span>' + FileSize + ' байт</span>'
      }
    }
  },
  computed: {
    ...mapState(
      {
        files: state => state.files,
        arrOfIcons: state => state.arrOfIcons,
        newPkgInChainNumber: state => state.piTransit.newPkgInChainNumber,
        packageCreated: state => state.piTransit.packageCreated,
        packageEdited: state => state.piTransit.packageEdited,
        editedPackageNumber: state => state.piTransit.editedPackageNumber,
        dismissCountDown1: state => state.piTransit.dismissCountDown1,
        dismissCountDown2: state => state.piTransit.dismissCountDown2,
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop
      }
    ),
    allFilesDeleted () {
      return this.editFiles.filter(file => file.deleted === true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 320px) and (max-width: 1023px) {
    .upload-caption {
      font-size: 12px;
    }
  }

  .required-documents {
    text-align: center;
    font-size: 16px;
    color: #37474F;
    margin: auto;
  }

  .documents-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    div {
      font-size: 14px;
      &::before {
        display: inline-block;
        content: '';
        -webkit-border-radius: 0.375rem;
        border-radius: 0.375rem;
        height: 0.25rem;
        width: 0.25rem;
        margin-right: 0.3rem;
        margin-bottom: 0.15rem;
        background-color: #37474F;
      }
    }
  }

  .additional-documents {
    text-align: center;
    font-size: 14px;
    color: #37474F;
    margin: auto;
  }

  .pkg-number, .package-created-date {
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 20px;
    span {
      font-weight: bold;
    }
  }

  .file-attachment {
    color: #37474F;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    display: inline-block;
  }

  .edit-files-wrapper {
    .attachments-wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      .attachment {
        margin-bottom: 16px;
        padding: 10px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
        position: relative;
        &:hover {
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
          cursor: pointer;
        }
        @extend .attachment-inner-container;
      }
      @media screen and (min-width: 1024px) {
        .attachment {
          margin-right: 16px;
        }
      }
    }
    @media screen and (min-width: 320px) and (max-width: 1023px) {
      .attachments-wrapper {
        justify-content: center;
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .edit-files-wrapper {
      padding-top: 16px;
      padding-left: 16px;
      border: 4px solid #cfd8dc !important;
    }
  }

  .up-edit-files-wrapper {
    position: relative;
    .attachments-wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      .up-attachment {
        margin-bottom: 16px;
        padding: 10px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
        position: relative;
        z-index: 1;
        &:hover {
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
          cursor: pointer;
        }
        @extend .attachment-inner-container;
      }
      @media screen and (min-width: 1024px) {
        .up-attachment {
          margin-right: 16px;
        }
      }
    }
    @media screen and (min-width: 320px) and (max-width: 1023px) {
      .attachments-wrapper {
        justify-content: center;
      }
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1023px) {
    .up-edit-files-wrapper {
      min-height: 130px;
    }
  }

  @media screen and (min-width: 1024px) {
    .up-edit-files-wrapper {
      padding-top: 16px;
      padding-left: 16px;
      min-height: 348px;
    }
  }

  .attachment-inner-container {
    display: flex;
    width: 100%;
    word-break: break-all;
    .file-icon-wrapper {
      margin-right: 10px;
      i {
        font-size: 32px;
        color: #78909C;
        min-height: 80px;
      }
      .remove-file-button {
        position: absolute;
        top: 5px;
        right: 5px;
        i {
          color: #E7161A;
          font-size: 21px;
        }
      }
    }
    @media screen and (min-width: 320px) and (max-width: 1023px) {
      .file-icon-wrapper {
        width: 32px;
        min-width: 32px;
      }
    }
    .attachment-name-wrapper {
      font-size: 14px;
      letter-spacing: 0.25px;
      line-height: 20px;
      color: #37474F;
      .max-file-size-error {
        color: #ad1013;
        font-size: 14px;
        position: absolute;
        left: 10px;
        bottom: 8px;
        font-weight: bold;
      }
      .file-size {
        position: absolute;
        right: 10px;
        bottom: 10px;
        color: #ffffff;
        font-weight: bold;
      }
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1023px) {
    .send-reset {
      .action-button {
        width: 100%;
        span {
          font-size: 14px;
          font-weight: 500;
          position: relative;
          bottom: 1px;
        }
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .send-reset {
      padding-right: 0px !important;
      padding-left: 0px !important;
      .action-button {
        width: 162px;
        height: 40px;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  button.close {
    outline: none !important;
  }

  .iframe-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 25px;
    height: 0;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }

  .example-drag {
    margin-bottom: 10px;
    label.btn {
      margin-bottom: 0;
      margin-right: 1rem;
    }
    .drop-active {
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      position: fixed;
      z-index: 2;
      opacity: .6;
      text-align: center;
      background: #000;
      border-radius: 0.3rem;
      outline: 0;
      h3 {
        margin: -.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: #fff;
        padding: 0;
      }
    }
    .file-uploads {
      z-index: 0;
      position: absolute !important;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
    }
    @media screen and (min-width: 1024px) {
      .file-uploads {
        width: calc(100% - 40px);
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .example-drag {
      text-align: center;
    }
  }
</style>
